import React from 'react';
import InputDropdown from "../Dropdowns/InputDropdown";
import {toast} from "react-toastify";

const AddressSelect = ({
                           value,
                           onChange,
                           disabled,
                           error
                       }) => {
    const postalCodeErrorText = 'Укажите полный адрес';

    const onChangeValue = (name, value, values) => {
        let error = null;
        if (value && !(values || {}).postalCode) {
            toast.error(postalCodeErrorText);
            error = postalCodeErrorText
        }
        onChange(name, value, error)
    }

    return (
        <InputDropdown
            error={error}
            name={'fullName'}
            url={'parcels/addresses/suggestionsWithoutDictionary'}
            disabled={disabled}
            value={value || ''}
            dependentFields={['postalCode']}
            onChange={onChangeValue}
        />
    );
};

export default AddressSelect;


// WEBPACK FOOTER //
// ./App/components/Field/AddressSelect.jsx